import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#5f7074] text-white">
      <div className="max-w-[1400px] mx-auto px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          <div className="md:col-span-1">
            <img
              src="https://static.readdy.ai/image/21e92476ad71fc9ba2123db9df7d7eb8/3ffc4ab5e308061b8151d721b5bb0a39.png"
              alt="GPsolutions"
              className="h-32 w-auto mb-6 brightness-0 invert"
            />
            <p className="text-sm text-white/80 font-light leading-relaxed">
              {t('footer.description')}
            </p>
          </div>

          <div>
            <h3 className="text-sm font-medium tracking-widest mb-6">{t('footer.services.title')}</h3>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-sm text-white/80 hover:text-white transition-colors font-light">
                  {t('footer.services.interiorDesign')}
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-white/80 hover:text-white transition-colors font-light">
                  {t('footer.services.construction')}
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-white/80 hover:text-white transition-colors font-light">
                  {t('footer.services.furniture')}
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-white/80 hover:text-white transition-colors font-light">
                  {t('footer.services.cnc')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-medium tracking-widest mb-6">{t('footer.company.title')}</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-sm text-white/80 hover:text-white transition-colors font-light">
                  {t('footer.company.about')}
                </Link>
              </li>
              <li>
                <Link to="/projects" className="text-sm text-white/80 hover:text-white transition-colors font-light">
                  {t('footer.company.projects')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-white/80 hover:text-white transition-colors font-light">
                  {t('footer.company.contact')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-medium tracking-widest mb-6">{t('footer.contact.title')}</h3>
            <ul className="space-y-3">
              <li className="text-sm text-white/80 font-light">
                GPR d.o.o.
              </li>
              <li className="text-sm text-white/80 font-light">
                Barutanski breg 78
              </li>
              <li className="text-sm text-white/80 font-light">
                Zagreb, Croatia
              </li>
              <li>
                <a href="mailto:info@gpsolutions.hr" className="text-sm text-white/80 hover:text-white transition-colors font-light">
                  info@gpsolutions.hr
                </a>
              </li>
              <li>
                <a href="tel:+385123456789" className="text-sm text-white/80 hover:text-white transition-colors font-light">
                  +385 91 234 2320
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-white/60 font-light mb-4 md:mb-0">
            {t('footer.copyright')} | <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">{t('footer.poweredBy')}</a>
          </p>
          <div className="flex items-center space-x-6">
            <a href="https://www.instagram.com/gpsolutions.hr/" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-white transition-colors" aria-label="Instagram">
              <i className="ri-instagram-line text-xl"></i>
            </a>
          </div>
        </div>
      </div>

      <button
        onClick={scrollToTop}
        className="fixed bottom-8 right-8 w-12 h-12 bg-[#5f7074] text-white rounded-full shadow-lg hover:bg-[#4f5f63] transition-all duration-300 flex items-center justify-center cursor-pointer z-40"
        aria-label="Scroll to top"
      >
        <i className="ri-arrow-up-line text-xl"></i>
      </button>
    </footer>
  );
}
